import styled from 'styled-components';

export const StyledSettingButtonDiv = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledNotificationsMobileHeader = styled.div`
  .mobile-header-item-wrapper {
    width: 100%;
    justify-content: space-between;
  }
`;
